export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'team_supervisor_manage',
  'team_coordinator_manage',
];

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'team_supervisor_manage',
  'team_coordinator_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const TEAM_SUPERVISOR_PERMISSION = 'team_supervisor_manage';
export const TEAM_COORDINATOR_PERMISSION = 'team_coordinator_manage';

// Estos roles ven sus propias conversaciones + las de los teams donde son
// supervisor/coordinator. A nivel UI deben ver los tabs habituales.
export const TEAM_SCOPE_PERMISSIONS = [
  'team_supervisor_manage',
  'team_coordinator_manage',
];

// Orden de las pestañas del listado: Mías, No leído, Sin asignar, Todos.
export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [
      ...ROLES,
      ...CONVERSATION_PERMISSIONS,
      ...TEAM_SCOPE_PERMISSIONS,
    ],
  },
  unread: {
    count: 'unreadCount',
    permissions: [
      ...ROLES,
      ...CONVERSATION_PERMISSIONS,
      ...TEAM_SCOPE_PERMISSIONS,
    ],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
      ...TEAM_SCOPE_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
      ...TEAM_SCOPE_PERMISSIONS,
    ],
  },
};
